<div>
  <div class="flex flex-col gap-5 md:flex-row md:items-end">
    <div>
      <h1 class="text-2xl font-semibold dark:text-white-light md:text-3xl">{{ 'transaction_details' | translate }}</h1>
    </div>
  </div>

  <!-- Filter Section -->
  <div class="mt-5 space-y-4">
    <!-- Row 1: Search, Status, and Toggle Button -->
    <div class="grid grid-cols-1 gap-4 md:grid-cols-3">
      <div>
        <label class="mb-2 block text-sm font-medium text-gray-700 dark:text-white-light">Search</label>
        <app-debounce-input
          (valueChange)="onInputChanged($event)"
          [delay]="600"
          class="w-full">
        </app-debounce-input>
      </div>

      <div>
        <label class="mb-2 block text-sm font-medium text-gray-700 dark:text-white-light">Status</label>
        <ng-select
          [items]="status"
          bindLabel="label"
          bindValue="value"
          [clearable]="true"
          placeholder="Select Status"
          class="custom-multiselect w-full"
          [(ngModel)]="params.status"
          (change)="onStatusChange($event)">
        </ng-select>
      </div>

      <div class="flex items-end">
        <button
          type="button"
          class="btn btn-primary w-full"
          (click)="toggleAdvancedFilters()">
          <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 inline-block ltr:mr-2 rtl:ml-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 4a1 1 0 011-1h16a1 1 0 011 1v2.586a1 1 0 01-.293.707l-6.414 6.414a1 1 0 00-.293.707V17l-4 4v-6.586a1 1 0 00-.293-.707L3.293 7.293A1 1 0 013 6.586V4z" />
          </svg>
          {{ showAdvancedFilters ? 'Hide Filters' : 'Show Filters' }}
        </button>
      </div>
    </div>

    <!-- Advanced Filters (Collapsible) -->
    <div *ngIf="showAdvancedFilters" class="space-y-4">
      <!-- Row 2: Date Range -->
      <div class="grid grid-cols-1 gap-4 md:grid-cols-2">
        <div>
          <label class="mb-2 block text-sm font-medium text-gray-700 dark:text-white-light">Created From</label>
          <ng2-flatpickr
            #createdFromPicker
            [config]="createdFromConfig"
            placeholder="Select start date"
            (change)="onCreatedFromChange($event)"
            addClass="form-input">
          </ng2-flatpickr>
        </div>

        <div>
          <label class="mb-2 block text-sm font-medium text-gray-700 dark:text-white-light">Created To</label>
          <ng2-flatpickr
            #createdToPicker
            [config]="createdToConfig"
            placeholder="Select end date"
            (change)="onCreatedToChange($event)"
            addClass="form-input">
          </ng2-flatpickr>
        </div>
      </div>

      <!-- Row 3: Product -->
      <div class="grid grid-cols-1 gap-4 md:grid-cols-2">
        <div>
          <label class="mb-2 block text-sm font-medium text-gray-700 dark:text-white-light">Product</label>
          <ng-select
            [items]="products"
            bindLabel="label"
            bindValue="value"
            [clearable]="true"
            placeholder="Select Product"
            class="custom-multiselect w-full"
            [(ngModel)]="params.productCode"
            (change)="onProductChange($event)">
          </ng-select>
        </div>
      </div>
    </div>
  </div>

  <div class="panel mt-4 pb-0">
    <div class="relative mb-3 pb-8">
      <button
        type="button"
        class="btn btn-primary btn-sm absolute right-0 top-0 z-10"
        (click)="downloadExcel()"
        [disabled]="loading">
        <icon-code-file class="ltr:mr-2 rtl:ml-2" />
        {{ loading ? 'Loading...' : 'EXCEL' }}
      </button>
    </div>
    <div class="datatable">
      <ng-datatable
        [isServerMode]="true"
        [rows]="rows"
        [columns]="cols"
        [loading]="loading"
        [totalRows]="totalRows"
        [pageSize]="params.rowPerPage"
        [search]="params.filter"
        [pageSizeOptions]="pageSizeOptions"
        (changeServer)="changeServer($event)"
        skin="whitespace-nowrap table-hover"
        firstArrow='<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" class="w-4.5 h-4.5 rtl:rotate-180"> <path d="M13 19L7 12L13 5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/> <path opacity="0.5" d="M16.9998 19L10.9998 12L16.9998 5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/> </svg>'
        lastArrow='<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" class="w-4.5 h-4.5 rtl:rotate-180"> <path d="M11 19L17 12L11 5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/> <path opacity="0.5" d="M6.99976 19L12.9998 12L6.99976 5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/> </svg> '
        previousArrow='<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" class="w-4.5 h-4.5 rtl:rotate-180"> <path d="M15 5L9 12L15 19" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/> </svg>'
        nextArrow='<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" class="w-4.5 h-4.5 rtl:rotate-180"> <path d="M9 5L15 12L9 19" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/> </svg>'
      >
        <ng-template slot="total" let-value="data">
          <div class='text-end'>{{ value.total | number:'1.0-0' }}</div>
        </ng-template>

        <ng-template slot="fine" let-value="data">
          <div class='text-end'>{{ value.fine | number:'1.0-0' }}</div>
        </ng-template>

        <ng-template slot="admin_merchant" let-value="data">
          <div class='text-end'>{{ value.admin_merchant | number:'1.0-0' }}</div>
        </ng-template>

        <ng-template slot="admin_provider" let-value="data">
          <div class='text-end'>{{ value.admin_provider | number:'1.0-0' }}</div>
        </ng-template>

        <ng-template slot="first_balance" let-value="data">
          <div class='text-end'>{{ value.first_balance | number:'1.0-0' }}</div>
        </ng-template>

        <ng-template slot="last_balance" let-value="data">
          <div class='text-end'>{{ value.last_balance | number:'1.0-0' }}</div>
        </ng-template>

        <ng-template slot="bill_amount" let-value="data">
          <div class='text-end'>{{ value.bill_amount | number:'1.0-0' }}</div>
        </ng-template>

        <ng-template slot="total_admin" let-value="data">
          <div class='text-end'>{{ value.total_admin | number:'1.0-0' }}</div>
        </ng-template>

        <ng-template slot="total_amount" let-value="data">
          <div class='text-end'>{{ value.total_amount | number:'1.0-0' }}</div>
        </ng-template>

        <ng-template slot="stand_meter" let-value="data">
          <div class='text-end'>{{ value.first_stand | number:'1.0-0' }} - {{ value.last_stand | number:'1.0-0' }}</div>
        </ng-template>

        <ng-template slot="first_stand" let-value="data">
          <div class='text-end'>{{ value.first_stand | number:'1.0-0' }}</div>
        </ng-template>

        <ng-template slot="last_stand" let-value="data">
          <div class='text-end'>{{ value.last_stand | number:'1.0-0' }}</div>
        </ng-template>


        <ng-template slot="updated_at" let-value="data">
          <div>{{ value.updated_at | date:'yyyy-MM-dd HH:mm:ss' }}</div>
        </ng-template>

        <ng-template slot="tx_detail" let-value="data">
          <div class='text-center'>
            Read More
          </div>
        </ng-template>
        <ng-template slot="action" let-value="data">
          <div class="flex items-center justify-end">
            <div>
              <button
                ngxTippy="Edit"
                type="button"
                class="stroke-green-700"
                (click)="goToForm(value.id)"
              >
                <icon-pencil class="mr-2 text-success"></icon-pencil>
              </button>
            </div>
            <div>
              <button
                ngxTippy="Delete"
                type="button"
                (click)="selectedId = value.id; modal.open()"
              >
                <icon-trash class="text-danger"></icon-trash>
              </button>
            </div>
          </div>
        </ng-template>
      </ng-datatable>

      <modal #modal>
        <ng-template #modalHeader>
          <h4 class="p-5 pb-0 text-lg font-bold">{{ modalData.header }}</h4>
        </ng-template>
        <ng-template #modalBody>
          <p>{{ modalData.body }}</p>
        </ng-template>
        <ng-template #modalFooter>
          <div class="flex flex-row items-center gap-2">
            <button
              type="button"
              (click)="modal.close()"
              [class]="'btn btn-outline-info ' + modalData.closeButtonClass"
            >
              {{ modalData.closeButtonLabel }}
            </button>
            <button
              type="button"
              (click)="onModalDeleteConfirm(selectedId)"
              [class]="'btn btn-danger ' + modalData.confirmButtonClass"
            >
              {{ modalData.confirmButtonLabel }}
            </button>
          </div>
        </ng-template>
      </modal>
    </div>
  </div>
</div>
